import React, { FunctionComponent } from 'react';

import { getErrorMessageFromHttpStatus } from './getErrorMessageFromHttpStatus';
import { getParsedApiError } from './getParsedApiError';

export interface ApiErrorDescriptionProps {
	error?: any; // This is an AxiosError<any>, but we dont want to have a dep to axios just for this declaration.
}

const ApiErrorDescription: FunctionComponent<ApiErrorDescriptionProps> = ({
	error,
}) => {
	const { statusCode, details } = getParsedApiError(error);
	if (!details) {
		return (
			<>
				<span>{getErrorMessageFromHttpStatus(statusCode)} </span>
				{statusCode && <span>Status code: {statusCode}</span>}
				{details && <div>Details: {details}</div>}
			</>
		);
	}

	return <span>{details}</span>;
};

export default ApiErrorDescription;
